<template>
  <div class="cm-instancias">
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Filtros
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col cols="12" md="4" sm="6">
                    <v-text-field
                      v-model="nuevoIdInstancia"
                      label="Agregar ID Instancia"
                      type="number"
                      min="1"
                      clearable
                      hide-details
                      @keydown.enter.prevent="agregarIdInstancia"
                    >
                      <template v-slot:append>
                        <v-btn x-small color="primary" @click="agregarIdInstancia">
                          Agregar
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="8" sm="6" class="d-flex align-center flex-wrap">
                    <v-chip
                      v-for="idInstancia in filtros.IdsIntancias"
                      :key="`id-instancia-${idInstancia}`"
                      small
                      close
                      class="ma-1"
                      @click:close="eliminarIdInstancia(idInstancia)"
                    >
                      {{ idInstancia }}
                    </v-chip>
                  </v-col>

                  <v-col cols="12" md="4" sm="6">
                    <VueCtkDateTimePicker v-model="filtros.FechaInicio" label="Fecha inicio" format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" />
                  </v-col>

                  <v-col cols="12" md="4" sm="6">
                    <VueCtkDateTimePicker v-model="filtros.FechaFin" :min-date="filtros.FechaInicio" label="Fecha fin"
                      format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay
                      buttonNowTranslation="Ahora" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn color="purple" @click="InformadorInstancias" :loading="InformadorInstanciasLoading">
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-tabs v-model="tab" background-color="transparent" grow>
      <v-tab>
        Paros
      </v-tab>
      <v-tab>
        Operaciones
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-data-table :headers="headersParos" :items="parosData" :loading="InformadorInstanciasLoading" />
      </v-tab-item>
      <v-tab-item>
        <v-data-table :headers="headersOperaciones" :items="operacionesData" :loading="InformadorInstanciasLoading" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import axios from 'axios';
import qs from "qs";

export default {
  data() {
    return {
      filtros: {
        IdsIntancias: [],
        FechaInicio: null,
        FechaFin: null,
      },
      nuevoIdInstancia: null,
      parosData: [],
      operacionesData: [],

      headersParos: [
        {
          text: "Id Paro",
          value: "idParo",
        },
        {
          text: "Paro Manual",
          value: "paroManual",
        },
        {
          text: "Id Usuario Extemporáneo",
          value: "idUsuarioExtemporaneo",
        },
        {
          text: "Id Rectificó",
          value: "idRectifico",
        },
        {
          text: "Id Paro Tipo",
          value: "idParoTipo",
        },
        {
          text: "Id Sub Paro Tipo",
          value: "idSubParoTipo",
        },
        {
          text: "Id Trabajo Orden",
          value: "idTrabajoOrden",
        },
        {
          text: "Id Trabajo Orden Detalle",
          value: "idTrabajoOrdenDetalle",
        },
        {
          text: "Id Operación Real",
          value: "idOperacionReal",
        },
        {
          text: "Id Área",
          value: "idArea",
        },
        {
          text: "Id Máquina Instancia",
          value: "idMaquinaIns",
        },
        {
          text: "Id Operador",
          value: "idOperador",
        },
        {
          text: "Id Equipo",
          value: "idEquipo",
        },
        {
          text: "Bloqueo Producción",
          value: "bloqueoProduccion",
        },
        {
          text: "Cantidad Reportada",
          value: "cantidadReportada",
        },
        {
          text: "Cantidad Scrap",
          value: "cantidadScrap",
        },
        {
          text: "Cantidad Retrabajo",
          value: "cantidadRetrabajo",
        },
        {
          text: "Inicio",
          value: "inicio",
        },
        {
          text: "Fin",
          value: "fin",
        },
        {
          text: "Reporte Inicio",
          value: "reporteInicio",
        },
        {
          text: "Reporte Fin",
          value: "reporteFin",
        },
        {
          text: "MQTT Clave",
          value: "mqttClave",
        },
        {
          text: "Número QA",
          value: "numeroQA",
        },
        {
          text: "OEM",
          value: "oem",
        },
        {
          text: "Proveedor",
          value: "proveedor",
        },
        {
          text: "Condición",
          value: "condicion",
        },
        {
          text: "Rectificó",
          value: "rectifico",
        },
        {
          text: "Paro Tipo",
          value: "paroTipo",
        },
        {
          text: "Sub Paro Tipo",
          value: "subParoTipo",
        },
        {
          text: "Trabajo Orden",
          value: "trabajoOrden",
        },
        {
          text: "Trabajo Orden Detalle",
          value: "trabajoOrdenDetalle",
        },
        {
          text: "Operación Real",
          value: "operacionReal",
        },
        {
          text: "Área",
          value: "area",
        },
        {
          text: "Máquina Instancia",
          value: "maquinaInstancia",
        },
        {
          text: "Operador",
          value: "operador",
        },
        {
          text: "Equipo",
          value: "equipo",
        },
        {
          text: "Remanufactura Tareas",
          value: "remanufacturaTareas",
        },
        {
          text: "Mantenimiento Alertas",
          value: "mantenimientoAlertas",
        },
        {
          text: "Paro Responsables",
          value: "paroResponsables",
        },
        {
          text: "Imágenes Calidad",
          value: "imagenesCalidad",
        },
        {
          text: "Paros Manuales",
          value: "parosManuales",
        },
      ],
      headersOperaciones: [],

      tab: 0,

      InformadorInstanciasLoading: false,
    }
  },
  methods: {
    agregarIdInstancia() {
      const idInstancia = Number(this.nuevoIdInstancia);
      if (!Number.isInteger(idInstancia) || idInstancia <= 0) return;

      if (this.filtros.IdsIntancias.includes(idInstancia)) {
        this.nuevoIdInstancia = null;
        return;
      }

      this.filtros.IdsIntancias = [...this.filtros.IdsIntancias, idInstancia].sort((a, b) => a - b);
      this.nuevoIdInstancia = null;
    },

    eliminarIdInstancia(idInstancia) {
      this.filtros.IdsIntancias = this.filtros.IdsIntancias.filter((id) => id !== idInstancia);
    },

    createHeaders(rows) {
      if (!Array.isArray(rows) || !rows.length || typeof rows[0] !== "object") return [];
      return Object.keys(rows[0]).map((key) => ({
        text: this.humanizeKey(key),
        value: key,
      }));
    },

    humanizeKey(key) {
      return String(key || "")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/^./, (char) => char.toUpperCase());
    },

    async InformadorInstancias() {
      this.InformadorInstanciasLoading = true;

      try {
        this.parosData = [];
        this.operacionesData = [];

        const response = await axios.get("ControlMaestro/InformadorInstanciaODT", {
          params: this.filtros,
          paramsSerializer: (params) => qs.stringify(params, { indices: false, skipNulls: true }),
        });

        this.parosData = Array.isArray(response.data?.paros) ? response.data.paros : [];
        this.operacionesData = Array.isArray(response.data?.operaciones) ? response.data.operaciones : [];
        this.headersOperaciones = this.createHeaders(this.operacionesData);
      } catch (error) {
        this.parosData = this.operacionesData = [];
        this.headersOperaciones = [];
        console.error("Error al obtener InformadorInstancias:", error);
      } finally {
        this.InformadorInstanciasLoading = false;
      }
    },
  }
}
</script>
